import type { depenses as Fr } from '../fr/depenses';

/** « depenses » in English — typed on the French: a missing sentence does not compile. */
export const depenses: typeof Fr = {
  titre: 'Petty cash',
  sousTitre: (devise) => `A separate cash box for small expenses · total in ${devise}`,
  enregistrerDepense: 'Record an expense',
  debutCaisse: 'Cash float',
  rendreCaisse: 'Return to the cash register',
  vide: {
    titre: 'Petty cash is empty',
    texte: 'Nothing left to spend. The owner must put in a cash float before the next expense.',
  },
  kpi: {
    reste: 'Left in petty cash', resteDetail: 'what can still be spent',
    pose: 'Put in this month',
    poseDontAilleurs: (m) => `of which ${m} from elsewhere`,
    poseAilleurs: 'from elsewhere, not from the cash register',
    poseCaisse: 'from the main cash register',
    depense: 'Spent this month',
    depenseConsomme: (pct) => `${pct}% of the float used`,
    depenseAucunFonds: 'no float put in this month',
    rendu: 'Returned to the cash register', renduDetail: 'what went back to the counter',
  },
  quiADepense: 'Who spent what',
  colonnesPersonnes: { personne: 'Person', operations: 'Transactions', depense: 'Spent' },
  depensesDe: (mois) => `Expenses for ${mois}`,
  aucunMouvement: 'No movements this month',
  colonnes: { date: 'Date', type: 'Type', achat: 'What was bought', par: 'By', montant: 'Amount' },
  piece: (p) => `receipt ${p}`,
  note: 'A float taken from the main cash register leaves its trace there: it shows in that month\'s summary as money out. A float from elsewhere does not touch it — it is up to you to say where the cash came from. Either way, the counter balance is no longer muddled by water and coffee.',
  saisieDepense: {
    aide: 'Say what was bought. The expense comes out of petty cash, not the counter.',
    bouton: 'Record the expense',
  },
  saisieFonds: {
    aideCaisse: 'This amount leaves the main cash register and goes into petty cash. Two linked lines: the main cash register keeps a record of it.',
    aideAilleurs: 'This money comes from elsewhere — your own pocket, a withdrawal already counted somewhere else. The main cash register is not debited.',
    bouton: 'Put in the float',
    libelleDefaut: (mois) => `Cash float — ${mois}`,
    dOu: 'Where this money comes from',
    deCaisse: 'From the main cash register',
    dAilleurs: 'From elsewhere',
    noteCaisse: 'The main cash register will be debited by the same amount, and the amount will show in its monthly summary as money out.',
    noteAilleurs: 'The main cash register will not change. Choose this when the cash does not come from the counter — otherwise you would make money disappear that never left it.',
  },
  saisieRendre: {
    titre: 'Return to the main cash register',
    aide: 'Whatever was not spent goes back to the counter. Two linked lines, just like on the way in.',
    bouton: 'Return to the counter',
    libelleDefaut: 'Return to the main cash register',
  },
  saisie: {
    enregistre: (titre, m) => `${titre} — ${m} recorded.`,
    echec: 'Saving failed.',
    montant: (devise) => `Amount (${devise})`,
    libelle: 'Description',
    libelleExemple: 'E.g. water and coffee for the counter',
    piece: 'Receipt',
    pieceAide: 'Receipt number, if there is one.',
  },
};
